import { Link } from "gatsby";
import React from "react";
import { Container, Icon, Menu, Sidebar } from "semantic-ui-react";
import { Media } from "utils/media";

type activePage = "home" | "articles" | "courses" | "dashboard" | string | null;

interface NavbarProps {
  activePage: activePage;
}

export const NavbarDesktop: React.FC<any> = ({ children, Links, Search }) => {
  return (
    <Menu size="large" stackable borderless fixed="top">
      <Container>
        {Links}
        {/* {Search} */}
      </Container>
    </Menu>
  );
};

interface NavbarMobileProps {}

interface NavbarMobileState {
  sidebarOpened: boolean;
}

// TODO: Refactor to functional component
class NavbarMobile extends React.Component<
  NavbarMobileProps,
  NavbarMobileState
> {
  state: NavbarMobileState = {
    sidebarOpened: false,
  };

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { Links, Search } = this.props;
    const { sidebarOpened } = this.state;

    // TODO: Use context or a cb to dim Layout pusher

    return (
      <React.Fragment>
        <Sidebar
          as={Menu}
          animation="overlay"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          {Links}
          <Menu.Item onClick={this.handleSidebarHide}>
            Close Sidebar
            <Icon name="x" />
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Menu size="large" borderless fixed="top">
            <Container>
              <Menu.Item onClick={this.handleToggle}>
                <Icon name="sidebar" />
              </Menu.Item>
              {/* {Search} */}
            </Container>
          </Menu>
        </Sidebar.Pusher>
      </React.Fragment>
    );
  }
}

export const Navbar: React.FC<NavbarProps> = props => {
  const { activePage } = props;
  const Links = (
    <>
      <Menu.Item header>Learn2Dev</Menu.Item>
      <Menu.Item as={Link} to="/" name="home" active={activePage === "home"} />
      <Menu.Item
        as={Link}
        to="/articles"
        name="Articles and Tutorials"
        active={activePage === "articles"}
      />
      <Menu.Item
        as={Link}
        to="/dashboard"
        name="Dashboard"
        active={activePage === "dashboard"}
      />
      <Menu.Item
        // as={Link}
        to="/courses"
        name="Courses"
        active={activePage === "courses"}
        disabled
        title="coming soon!"
      />
    </>
  );

  // TODO: Search is disabled for now
  const Search = (
    <Menu.Menu position="right">
      <div className="ui right aligned category search item">
        <div className="ui transparent icon input">
          <input className="prompt" type="text" placeholder="Search..." />
          <i className="search link icon" />
        </div>
        <div className="results" />
      </div>
    </Menu.Menu>
  );

  // TODO: Get mobile navbar working

  return (
    <React.Fragment>
      <Media as={Sidebar.Pushable} at="mobile">
        <NavbarMobile Links={Links} Search={Search} />
      </Media>

      <Media greaterThan="mobile">
        <NavbarDesktop Links={Links} Search={Search} />
      </Media>
    </React.Fragment>
  );
};

export default Navbar;
